import { useMemo } from 'react';
import * as Icons from '@tabler/icons';

export const renderIcon = (icon: string) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const Icon = useMemo(() => Icons[icon as keyof typeof Icons], [icon]);
    return <Icon stroke={1.5} size="20px" />;
};
